import { call, put, takeLatest } from 'redux-saga/effects';
import * as T from './loyaltyAutomatedRewardsTypes';
import * as A from './loyaltyAutomatedRewardsActions';
import { listRewards } from '../../../services/rewardCatalogApi';
import type { Reward } from '../../../components/loyalty/data/types';

function* fetchAutomatedRewardsSaga() {
  try {
    const response: Awaited<ReturnType<typeof listRewards>> = yield call(listRewards, {
      isautomatedreward: true,
    } as any);
    const rewards: Reward[] = response?.data?.rewards ?? [];
    yield put(A.fetchAutomatedRewardsSuccess(rewards));
  } catch (e: any) {
    yield put(A.fetchAutomatedRewardsFailure(e.message || 'Failed to fetch automated rewards'));
  }
}

export default function* loyaltyAutomatedRewardsSaga() {
  yield takeLatest(T.FETCH_AUTOMATED_REWARDS_REQUEST, fetchAutomatedRewardsSaga);
}
